/* ATEM Analytics, 2026-09-15.
   Two jobs on one file, so the store loads one extra script and not two:
   1. keeps the ad click id and the traffic source of the visit and drops them into the
      quote form as hidden fields, so the lead arrives with its source next to the name
      and the email instead of showing up as direct in the CRM;
   2. sends a click_to_call event to GA4 when a visitor taps the phone number, which the
      site has never measured.

   Runs on every page: the click id usually lands on the entry page, while the form is
   opened one or two pages later. Storage is localStorage with a 90 day life, which
   matches the Google Ads conversion window. */
(function () {
  'use strict';

  var KEY = 'nsbd_attr';
  var SESSION_KEY = 'nsbd_session_origin';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var CLICK_PARAMS = ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid'];
  var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function readStore() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.ts || (Date.now() - data.ts) > MAX_AGE_MS) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeStore(data) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      /* private mode or storage full: the form still gets whatever is in the URL now */
    }
  }

  function params() {
    var out = {};
    var q = window.location.search.replace(/^\?/, '');
    if (!q) return out;
    var parts = q.split('&');
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split('=');
      if (!pair[0]) continue;
      try {
        out[decodeURIComponent(pair[0])] = decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
      } catch (e) {
        out[pair[0]] = pair[1] || '';
      }
    }
    return out;
  }

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* Google writes _gcl_aw as GCL.<timestamp>.<gclid>; it survives a page change even
     when the click id is no longer in the URL. */
  function clickIdFromCookie() {
    var raw = cookie('_gcl_aw');
    if (!raw) return '';
    var parts = raw.split('.');
    return parts.length >= 3 ? parts.slice(2).join('.') : '';
  }

  function collect() {
    var p = params();
    var stored = readStore();
    var clickId = '';
    var clickSource = '';

    for (var i = 0; i < CLICK_PARAMS.length; i++) {
      if (p[CLICK_PARAMS[i]]) {
        clickId = p[CLICK_PARAMS[i]];
        clickSource = CLICK_PARAMS[i];
        break;
      }
    }

    /* A fresh click in the URL always wins over what was kept from an earlier visit. */
    if (clickId) {
      var fresh = {
        ts: Date.now(),
        click_id: clickId,
        click_param: clickSource,
        utm: {},
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || ''
      };
      for (var j = 0; j < UTM_PARAMS.length; j++) {
        if (p[UTM_PARAMS[j]]) fresh.utm[UTM_PARAMS[j]] = p[UTM_PARAMS[j]];
      }
      writeStore(fresh);
      return fresh;
    }

    /* No click id, but campaign tags are present: keep them as the current visit. */
    var hasUtm = false;
    for (var k = 0; k < UTM_PARAMS.length; k++) {
      if (p[UTM_PARAMS[k]]) { hasUtm = true; break; }
    }
    if (hasUtm) {
      var utmOnly = {
        ts: Date.now(),
        click_id: clickIdFromCookie(),
        click_param: '',
        utm: {},
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || ''
      };
      for (var n = 0; n < UTM_PARAMS.length; n++) {
        if (p[UTM_PARAMS[n]]) utmOnly.utm[UTM_PARAMS[n]] = p[UTM_PARAMS[n]];
      }
      writeStore(utmOnly);
      return utmOnly;
    }

    if (stored) {
      if (!stored.click_id) stored.click_id = clickIdFromCookie();
      return stored;
    }

    /* Plain visit: no ad click, no campaign tags. The entry page and the referrer of THIS
       session are what matter, so they are written once and reused on every later page.
       Without this, a visitor who arrives from Google search and opens the form two clicks
       later hands the lead the store's own URL as its referrer. */
    var origin = null;
    try {
      origin = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) || 'null');
    } catch (e) {}

    if (!origin) {
      var ref = document.referrer || '';
      var internal = false;
      try {
        internal = !!ref && new URL(ref).hostname === window.location.hostname;
      } catch (e) {}
      origin = {
        landing_page: window.location.pathname + window.location.search,
        referrer: internal ? '' : ref
      };
      try { window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(origin)); } catch (e) {}
    }

    return {
      ts: Date.now(),
      click_id: clickIdFromCookie(),
      click_param: '',
      utm: {},
      landing_page: origin.landing_page,
      referrer: origin.referrer
    };
  }

  function describe(data) {
    var bits = [];
    if (data.utm && data.utm.utm_source) {
      bits.push(data.utm.utm_source + (data.utm.utm_medium ? ' / ' + data.utm.utm_medium : ''));
      if (data.utm.utm_campaign) bits.push('campaign: ' + data.utm.utm_campaign);
      if (data.utm.utm_term) bits.push('term: ' + data.utm.utm_term);
    } else if (data.click_param === 'gclid' || data.click_param === 'gbraid' || data.click_param === 'wbraid') {
      bits.push('Google Ads');
    } else if (data.click_param === 'msclkid') {
      bits.push('Microsoft Ads');
    } else if (data.click_param === 'fbclid') {
      bits.push('Meta');
    } else if (data.click_id) {
      bits.push('Google Ads (from _gcl_aw)');
    } else if (data.referrer) {
      try {
        var host = new URL(data.referrer).hostname.replace(/^www\./, '');
        var engines = ['google.', 'bing.', 'duckduckgo.', 'yahoo.', 'ecosia.', 'search.brave.'];
        var isSearch = false;
        for (var s = 0; s < engines.length; s++) {
          if (host.indexOf(engines[s]) === 0) { isSearch = true; break; }
        }
        bits.push((isSearch ? 'organic search: ' : 'referral: ') + host);
      } catch (e) {
        bits.push('referral');
      }
    } else {
      bits.push('direct or organic');
    }
    return bits.join(' | ');
  }

  function fill() {
    var form = document.getElementById('ns-event-contact-form');
    if (!form) return;
    var data = collect();
    var values = {
      'ns-cf-click-id': data.click_id || '',
      'ns-cf-click-param': data.click_param || '',
      'ns-cf-traffic-source': describe(data),
      'ns-cf-landing-page': data.landing_page || '',
      'ns-cf-referrer': data.referrer || ''
    };
    for (var id in values) {
      if (!Object.prototype.hasOwnProperty.call(values, id)) continue;
      var el = document.getElementById(id);
      if (el) el.value = values[id];
    }
  }

  /* Phone taps. The number sits in the header and the footer of every page and was the
     one lead path with no measurement at all: G | Calls from website is Inactive in Google
     Ads and nothing on the site ever fired for it. The event is sent to GA4 through the
     Google tag that is already on the page. A Google Ads conversion for calls needs a
     conversion label from the Ads account and is added on top once that label exists. */
  function trackCalls() {
    document.addEventListener('click', function (ev) {
      var el = ev.target;
      while (el && el !== document.body) {
        if (el.tagName === 'A' && (el.getAttribute('href') || '').indexOf('tel:') === 0) {
          var number = el.getAttribute('href').replace('tel:', '');
          try {
            /* The Google tag reads dataLayer as an arguments list, not as objects, so a
               tap that happens before gtag is defined is queued in that same shape and is
               picked up when the tag loads. An object push would be dropped. */
            window.dataLayer = window.dataLayer || [];
            var payload = {
              phone_number: number,
              link_text: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60),
              page_location: window.location.href
            };
            if (typeof window.gtag !== 'function') {
              window.gtag = function () { window.dataLayer.push(arguments); };
            }
            window.gtag('event', 'click_to_call', payload);
          } catch (e) {
            /* never let measurement block the call itself */
          }
          return;
        }
        el = el.parentNode;
      }
    }, true);
  }

  collect();
  trackCalls();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fill);
  } else {
    fill();
  }
})();
